import { DEFAULT_STEP_OPTIONS } from '../../constants/onboarding';
import { Flex } from '@ttoss/ui';
import { PROPERTIES_MODULE } from '../../constants/featureFlag';
import { Steps } from 'intro.js-react';
import { useCurrentLocation } from 'src/providers/CurrentLocationProvider/CurrentLocationProvider';
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../providers/NavigationProvider/NavigationProvider';
import BadgeButton from '../BadgeButton/BadgeButton';
import React, { useState } from 'react';
import type { SubMenuType } from './SubMenuType';

export type SubMenuProps = {
  selected?: SubMenuType;
  onClick?: (menu: SubMenuType) => void;
};

const SubMenu = ({ selected, onClick }: SubMenuProps) => {
  const [menuSelected, setMenuSelected] = useState(selected);

  const { onNavigate } = useNavigation();

  const navigate = useNavigate();

  const handleSelect = (menu: SubMenuType) => {
    onClick?.(menu);
    onNavigate?.(menu);
    setMenuSelected(menu);
  };

  const [state, setState] = React.useState({
    stepsEnabled: false,
    initialStep: 0,
    steps: [
      {
        intro:
          'A funcionalidade de salvar está sendo desenvolvida e logo estará no ar',
      },
    ],
  });

  const onExit = () => {
    setState((prev) => {
      return { ...prev, stepsEnabled: false };
    });
  };

  const { latLng } = useCurrentLocation();

  const showSaveButton = PROPERTIES_MODULE && latLng;

  return (
    <Flex className="badge-menu-group" sx={{ gap: 6, padding: 6 }}>
      <Steps
        enabled={state.stepsEnabled}
        steps={state.steps}
        initialStep={state.initialStep}
        onExit={onExit}
        options={{
          ...DEFAULT_STEP_OPTIONS,
          doneLabel: 'Ok',
          skipLabel: '',
        }}
      />

      <BadgeButton
        onClick={() => {
          return handleSelect('recommendation');
        }}
        label="Espécies/Clones"
        icon="open-plants-result"
        selected={menuSelected === 'recommendation'}
        aria-label="recommendation"
        className="badge-menu-recommendation"
      />

      <BadgeButton
        onClick={() => {
          return handleSelect('biophysics');
        }}
        label="Biofísico"
        selected={menuSelected === 'biophysics'}
        icon="ic:outline-layers"
        aria-label="biophysics"
        className="badge-menu-biophysics"
      />

      {showSaveButton && (
        <BadgeButton
          onClick={() => {
            navigate('/cadastro-propriedade');
          }}
          label="Salvar"
          selected={menuSelected === 'save'}
          icon="ic:baseline-bookmark-border"
          aria-label="save"
          className="badge-menu-save"
        />
      )}
    </Flex>
  );
};

export default SubMenu;
